import axiosInstance from "../../../../app/myAxiosInstance";
const baseApiUrl = process.env.REACT_APP_HOST + process.env.REACT_APP_BASE_API_URL;

/**
 * Method to get my score
 * @param {Object} data 
 */
async function getMyScore(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/productivity/score`, { params: data });
        return result;
    } catch (err) {
        console.error('error in getting score ', err);
    }

}
async function getCityScore(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/productivity/score/city`, { params: data });
        return result;
    } catch (err) {
        console.error('error in getting score ', err);
    }

}
async function getLeaderboard(data) {
    try {
        const result = await axiosInstance.get(`${baseApiUrl}admin/productivity/score/getLeaderboard`, { params: data });
        return result;
    } catch (err) {
        console.error('error in getting LeaderboardData ', err);
    }

}
async function getSupervisorLeaderBoard(data) {
    try{
        const result = await axiosInstance.get(`${baseApiUrl}admin/productivity/score/getSupervisorLeaderboard`, {params: data});
        return result;
    } catch (error) {
        console.error('error in getting Supervisor leaderboard Data', error);
    }
}

async function getPmList(data) {
    try{
        const result = await axiosInstance.get(`${baseApiUrl}admin/productivity/score/getPmCityWise`, {params: data});
        return result;
    }catch(error){
        console.log("Error in getting PM list", error);
    }
}

export const productivityServices = {
    getMyScore,
    getLeaderboard,
    getCityScore,
    getSupervisorLeaderBoard,
    getPmList
};